export const config = {
    apiBase: "https://rise.infinityideas.dev/api/",
    imageSqH: 350,
    exp_numseqs: 10,
}